// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__8FumI","mbp":"navbar_mbp__wsnTL","logo":"navbar_logo__7LxWv","name":"navbar_name__BnhIe","nav-button":"navbar_nav-button__GuNHX"};